import { createContext } from 'react';
import type { RenderView } from '../potree/viewer/RenderView';

/**
 * Carries the active widget's RenderView (with its RenderViewState) to
 * descendants. When this context is non-null, components like
 * <ViewSelector> route to the per-view ViewManager substitute instead of
 * the global one — letting the same component drive both the main view
 * and any number of widgets without forking the UI.
 *
 * The main view does NOT provide this context — `useViewManager()` falls
 * through to the global ViewManager as it always has.
 */
export const RenderViewContext = createContext<RenderView | null>(null);
